import React, { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { observer } from 'mobx-react-lite';
import { loadStripe } from '@stripe/stripe-js';
import { useMst } from '../../../models/stores/Root';
import StripePaymentRequestButton from '../StripePaymentRequestButton';

const WrappedStripePaymentRequestButton: React.FC = observer(() => {
  const rootStore = useMst();
  const { configuration } = rootStore;
  const {
    payments: {
      stripeApiVersion,
      stripeBetaVersion,
      stripePublicKey,
      stripeMerchantId,
    },
  } = configuration;

  const stripePromise = useMemo(() => {
    if (!stripePublicKey || !stripeApiVersion || !stripeBetaVersion) {
      return Promise.resolve(null);
    }

    let stripeAccount: string | undefined;
    if (stripeMerchantId === null) {
      stripeAccount = undefined;
    } else {
      stripeAccount = stripeMerchantId;
    }

    return loadStripe(stripePublicKey, {
      apiVersion: stripeApiVersion,
      betas: [stripeBetaVersion],
      stripeAccount,
    });
  }, [stripePublicKey, stripeApiVersion, stripeBetaVersion, stripeMerchantId]);

  return (
    <Elements stripe={stripePromise}>
      <StripePaymentRequestButton />
    </Elements>
  );
});

export default WrappedStripePaymentRequestButton;
